import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, Col, Divider, Form, message, Modal, Row, Spin, Typography } from 'antd'
import PartnerDocuments from '../Sections/PartnerDocuments'
import { errors, profileScreen } from '../../../../translates'
import {
  useMutateAdminAcceptRequisitesForm,
  useMutateAdminDeclineRequisitesForm,
  useQueryAdminRequisitesForm
} from '../../../../api/react-query/adminPartners'
import { ACCEPTED, NONE } from '../../../../Constants'
import {
  validateBankAccount,
  validateBankAccountIndividualFull, validateBankAccountLegalBoth,
  validateBankAccountSelfEmployed, validateBankBik, validateFullBankAccount, validateNameRus
} from '../../../../helper'
import './EditModals.css'
import { adminReducerActions, AppConfig, individual, selfEmployed } from '../../../../AppConfig'
import { ConfigContext } from '../../../../context/configContext'
import { BankAccountFormItem, BankBikFormItem, NameFormItem } from '../../../Common'
import './EditBankRequisites.css'
import { useGetPartnerId } from '../../../../hooks/useGetPartnerId'
import ApprovalAction from '../../Approval/ApprovalAction'
const { Text } = Typography
const documents = [profileScreen.input.requisitesBankPhoto.name]

function EditBankRequisites ({ disabled, viewOnly = true }) {
  const partnerId = useGetPartnerId()
  const { user, portalButtonState, isCoordinator, isExternalCoordinator, partnerData: partner, setConfig } = useContext(ConfigContext)
  const { profile } = partner
  const [form] = Form.useForm()
  const [isFormValid, setIsFormValid] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)

  const {
    data: requisitesFormData,
    isFetching: isLoadingRequisitesFormData
  } = useQueryAdminRequisitesForm(partnerId, {
    enabled: isModalVisible,
    refetchOnWindowFocus: false,
    staleTime: 0,
    cacheTime: 0
  })

  const {
    mutateAsync: acceptRequestAsync,
    isLoading: acceptRequestLoading
  } = useMutateAdminAcceptRequisitesForm()

  const {
    mutateAsync: declineRequestAsync,
    isLoading: declineRequestLoading
  } = useMutateAdminDeclineRequisitesForm()

  const showModal = () => {
    if (user?.online && (isCoordinator || isExternalCoordinator)) {
      portalButtonState?.stopStatusRequesting()
    }
    setIsModalVisible(true)
  }
  const handleCancel = () => {
    if (user?.online && (isCoordinator || isExternalCoordinator)) {
      portalButtonState?.startStatusRequesting()
    }
    setIsModalVisible(false)
  }

  const handleAccept = async () => {
    try {
      const result = await acceptRequestAsync({
        id: partnerId,
        data: form.getFieldsValue()
      })
      if (result.isSuccess) {
        message.success('Запрос на изменение данных принят.')
        setConfig({
          type: adminReducerActions.updatePartner,
          value: result.partner
        })
        handleCancel()
        return
      }
      message.error(result.errorMessage)
    } catch (error) {
      message.error('Не удалось принять запрос.')
    }
  }

  const handleDecline = async ({ comment, additionalComment }) => {
    try {
      const result = await declineRequestAsync({ id: partnerId, reason: comment, description: additionalComment })
      if (result.isSuccess) {
        setConfig({
          type: adminReducerActions.updatePartner,
          value: result.partner
        })
        message.success('Запрос на изменение данных отклонен.')
        handleCancel()
        return
      }
      message.error(result.errorMessage)
    } catch (error) {
      message.error('Не удалось отклонить запрос.')
    }
  }

  useEffect(() => {
    if (!requisitesFormData?.isSuccess) return
    form.setFieldsValue(requisitesFormData.form)
    !viewOnly && form.validateFields().then().catch(() => {})
  }, [form, requisitesFormData, viewOnly])

  const onFieldsChange = () => {
    const errors = form.getFieldsError()
    setIsFormValid(!errors.some(field => field.errors.length > 0))
  }

  const handleChangeBik = () => {
    if (form?.getFieldValue([profileScreen.input.requisitesbankAccount.name])) {
      form.validateFields([[profileScreen.input.requisitesbankAccount.name]])
        .catch(() => {})
    }
  }

  return (
    <>
      <Button
        ghost
        type='primary'
        className='w-150'
        disabled={disabled}
        onClick={showModal}
      >
        {viewOnly ? 'Посмотреть' : 'Проверить'}
      </Button>
      <Modal
        width={1200}
        style={{ top: 20 }}
        title={
          <Row gutter={[12, 6]} align='middle'>
            <Col className='mr-3'><b>Данные о банковских реквизитах</b></Col>
          </Row>
        }
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        className='assetsModalForm'
      >
        <Row className='mb-3'>
          <Text underline>Полное ФИО: <b>{requisitesFormData?.form?.[profileScreen.input.requisitesname.name]}</b></Text>
        </Row>
        <Row className='mb-3'>
          <Text underline>Тип занятости: <b>{profile?.personalData?.legalForm}</b></Text>
        </Row>
        {profile?.personalData?.taxSystem && (
          <Row className='mb-3'>
            <Text underline>Система налогообложения: <b>{profile?.personalData?.taxSystem}</b></Text>
          </Row>
        )}
        <Spin spinning={isLoadingRequisitesFormData || acceptRequestLoading || declineRequestLoading}>
          {
            requisitesFormData?.form?.statusReason &&
              <Alert
                className='mb-3'
                message={<Text type='secondary'>Причины отказа</Text>}
                description={
                  <>
                    {requisitesFormData?.form.statusReason}
                    {requisitesFormData?.form?.statusDescription && (
                      <div style={{ marginTop: '1rem' }}>
                        <div className='ant-alert-message'>
                          <Text type='secondary'>Уточнение причины</Text>
                        </div>
                        {requisitesFormData?.form?.statusDescription}
                      </div>
                    )}
                  </>
                }
                type='error'
              />
          }
          <Form form={form} onFieldsChange={onFieldsChange}>
            <div className='edit-bank-requisite'>
              <Row style={{ backgroundColor: '#fafafa' }}>
                <Col span={7}>
                  Название поля
                </Col>
                <Col span={17}>
                  Значение
                </Col>
              </Row>
              <Row>
                <Col span={7} style={{ alignContent: 'center' }}>
                  {profileScreen.input.requisiteslastName.label}
                </Col>
                <Col span={17}>
                  <NameFormItem
                    label=''
                    disabled={viewOnly}
                    name={[profileScreen.input.requisiteslastName.name]}
                    placeholder={profileScreen.input.surname.placeholder}
                    rules={[{ required: true, message: errors.nameRus, validator: validateNameRus }]}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={7} style={{ alignContent: 'center' }}>
                  {profileScreen.input.requisitesfirstName.label}
                </Col>
                <Col span={17}>
                  <NameFormItem
                    label=''
                    disabled={viewOnly}
                    name={[profileScreen.input.requisitesfirstName.name]}
                    placeholder={profileScreen.input.surname.placeholder}
                    rules={[{ required: true, message: errors.nameRus, validator: validateNameRus }]}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={7} style={{ alignContent: 'center' }}>
                  {profileScreen.input.requisitespatronymic.label}
                </Col>
                <Col span={17}>
                  <NameFormItem
                    label=''
                    disabled={viewOnly}
                    name={[profileScreen.input.requisitespatronymic.name]}
                    placeholder={profileScreen.input.surname.placeholder}
                    rules={[{ required: true, message: errors.nameRus, validator: validateNameRus }]}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={7} style={{ alignContent: 'center' }}>
                  {profileScreen.input.requisitesbankAccount.label}
                </Col>
                <Col span={17}>
                  <BankAccountFormItem
                    label=''
                    disabled={viewOnly}
                    name={[profileScreen.input.requisitesbankAccount.name]}
                    placeholder={profileScreen.input.requisitesbankAccount.placeholder}
                    rules={[
                      {
                        required: true,
                        message: profileScreen.input.requisitesbankAccount.message,
                        validator: validateBankAccount
                      },
                      ...(
                        profile?.personalData?.legalForm === individual ? [{ // individual
                          validator: (rule, value) => validateBankAccountIndividualFull(rule, value, profile.personalData)
                        }] : profile?.personalData?.legalForm === selfEmployed ? [{ // selfEmployed
                          message: errors.bankAccountSelf,
                          validator: validateBankAccountSelfEmployed
                        }] : [{
                          message: errors.bankAccountLegalBoth,
                          validator: validateBankAccountLegalBoth
                        }]
                      ),
                      {
                        message: errors.bankBikAccount,
                        validator: (rule, value) => validateFullBankAccount({
                          rule,
                          account: value,
                          bik: form?.getFieldValue([profileScreen.input.requisitesbankBik.name])
                        })
                      }
                    ]}
                    classNameInput='noScrollNumber'
                  />
                </Col>
              </Row>
              <Row>
                <Col span={7} style={{ alignContent: 'center' }}>
                  {profileScreen.input.requisitesbankBik.label}
                </Col>
                <Col span={17}>
                  <BankBikFormItem
                    label=''
                    disabled={viewOnly}
                    name={[profileScreen.input.requisitesbankBik.name]}
                    placeholder={profileScreen.input.requisitesbankBik.placeholder}
                    rules={[{ required: true, message: profileScreen.input.requisitesbankBik.message, validator: validateBankBik }]}
                    classNameInput='noScrollNumber'
                    onChange={handleChangeBik}
                  />
                </Col>
              </Row>
            </div>
            <Divider style={{ border: 0 }} />
            <PartnerDocuments
              partnerId={partnerId}
              documents={documents}
              profile={requisitesFormData?.form}
              getDocumentStatus={(d) => profile?.[d]?.fileId === requisitesFormData?.form?.[d]?.fileId ? ACCEPTED : NONE}
              getDocumentButton={() => null}
              correctForm={AppConfig.updateDocFormNames.bankRequisitesForm}
            />
            <Divider />
            {
              viewOnly ? (
                <Button type='primary' onClick={handleCancel}>Закрыть</Button>
              ) : (
                <ApprovalAction
                  targetType={AppConfig.reasonTargets.requisitesDetails}
                  disabled={!isFormValid}
                  onClose={handleCancel}
                  onAccept={handleAccept}
                  onDecline={(comment, additionalComment) => handleDecline({ comment, additionalComment })}
                  isShowDescription
                />
              )
            }
          </Form>
        </Spin>
      </Modal>
    </>
  )
}

export default EditBankRequisites
